export const FEDOPS_APP_NAMES = {
  INBOX: 'inbox',
  INBOX_TAB: 'inbox-tab',
};
